module.exports = "#grey-bg{\n    background-color: #f1f2f4;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/community-management/bill-management/bill-management.component.css
// module id = ./src/app/community-management/bill-management/bill-management.component.css
// module chunks = main